import { css } from 'styled-components';

/**
 * Hands the tab strip over to the browser's own horizontal scrolling.
 * rc-tabs otherwise hides overflowing tabs behind a "more" dropdown and
 * scrolls the list by translating it, neither of which we want here.
 */
export const getScrollArrowStyles = () => css`
  /* The scroller has to be the nav, not the nav wrapper inside it: rc-tabs
     holds a ref to the wrapper and resets its scrollLeft to 0 on every tab
     focus, which would wipe our position mid-click. AntD reaches these nodes
     through \`.ant-tabs-top > div > .ant-tabs-nav\` and is injected after us,
     so each override needs the repeated-class bump from \`&&&\`. */
  &&& .ant-tabs-nav {
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  /* Stops clipping so the tabs reach the nav's scroll area. */
  &&& .ant-tabs-nav-wrap {
    overflow: visible;

    /* rc-tabs' own edge shadows — ScrollableRow's fades replace them. */
    &::before,
    &::after {
      display: none;
    }
  }

  /* Inline transform from rc-tabs' scroll logic; native scrolling replaces it. */
  &&& .ant-tabs-nav-list {
    transform: none !important;
  }

  /* Redundant once every tab is reachable by scrolling. */
  &&& .ant-tabs-nav-operations {
    display: none;
  }
`;
